export interface ClaimBenefitDetail {
  claimNumber?: string
  detailBenefit?: string | null
}

export const isBenefitDetailMissing = (
  claimDetails: ClaimBenefitDetail | null | undefined
): boolean => {
  const detailBenefit = claimDetails?.detailBenefit

  return detailBenefit === null || detailBenefit === undefined || detailBenefit === 'null'
}
